import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BackdropLoader, OccupancySelector, toast } from '@livable/saas-react-components';
import { Alert, Button, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import useStyles from '../styles';
export const OccupancyTab = observer(_ref => {
  let residencyId = _ref.residencyId,
    parentToggleRefreshCallback = _ref.parentToggleRefreshCallback;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(1),
    _useState2 = _slicedToArray(_useState, 2),
    occupancy = _useState2[0],
    setOccupancy = _useState2[1];
  const _useState3 = useState(1),
    _useState4 = _slicedToArray(_useState3, 2),
    asyncOccupancy = _useState4[0],
    setAsyncOccupancy = _useState4[1];
  const handleOccupancyChange = (e, value) => {
    if (value) setOccupancy(value);
  };
  const handleSubmit = async () => {
    const data = {
      residencyId: residencyId,
      occupancy: occupancy
    };
    const resp = await store.residencies.updateResidencyOccupancyAsync.run(data);
    if (resp && resp.isSuccessful) {
      setAsyncOccupancy(occupancy);
      // eslint-disable-next-line @typescript-eslint/no-unused-expressions
      parentToggleRefreshCallback && parentToggleRefreshCallback();
      toast('success', {
        body: ['Successfully submitted']
      });
    }
  };
  useEffect(() => {
    const getResidencyOccupancyAsync = async data => {
      const resp = await store.residencies.getResidencyOccupancyAsync.run(data);
      return resp;
    };
    getResidencyOccupancyAsync({
      residencyId: residencyId
    }).then(async resp => {
      if (!resp) {
        return;
      }
      setOccupancy(resp.response.occupancy);
      setAsyncOccupancy(resp.response.occupancy);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: classes.tabWithFooter
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.alertWrapper
  }, /*#__PURE__*/React.createElement(Alert, {
    severity: "info",
    icon: false,
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('unit_modal.keep_number')), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, t('unit_modal.occupancy_number_text')))), /*#__PURE__*/React.createElement(OccupancySelector, {
    currentValue: occupancy,
    handleChange: handleOccupancyChange,
    fieldName: "occupancy",
    title: t('unit_modal.how_many_people'),
    disabled: store.company.companyFeatureStore.readOnlyOccupancyChange
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.footer
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "contained",
    onClick: handleSubmit,
    disabled: occupancy === asyncOccupancy,
    'custom-attribute': '257-occupancy-tab'
  }, t('buttons.submit'))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: store.residencies.getResidencyOccupancyAsync.inProgress || store.residencies.updateResidencyOccupancyAsync.inProgress
  }));
});